// src/utils/hotjar.ts
export function TrackHotjarEvent(eventName) {
  if (typeof window !== "undefined" && typeof window.hj === "function") {
    window.hj("event", eventName);
  }
}
